"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.last = void 0;
exports.last = (values) => values[values.length - 1];
//# sourceMappingURL=last.js.map